module.exports = __webpack_public_path__ + "img/touxiang2.b39630da.png";